





















import Vue, { PropOptions } from 'vue';
import * as models from '@/class/models/views/graph';
import { NOC } from '@/class/common/const' ;

export default Vue.extend({
  name: 'MaterialsListV3',
  props: {
    title: String,
    idkey: String,
    select: Array as PropOptions<models.IDomain[]>,
    materials: Array,
  },
  data() {
    return {
      selectMaterials: [] as models.IDomain[],
    };
  },
  methods: {
    onClickMaterial(material: models.IDomain) {
      this.$emit('select', material);
    },
    classMaterialButton(material: models.IDomain) {
      // 時が選択されている場合、残業時間・インターバル時間を非活性化
      if (this.select.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_HOUR.id)) {
        if (material.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_OVER_TIME.id || material.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_INTERVAL_TIME.id) {
          return {selected: false, darken_nopointer: true};
        }
      }

      return {
        selected: this.select.some((v) => (v.id === material.id) ),
        // darken: this.select.filter((v) => (v.reject.indexOf(material.id) !== -1)).length > 0 ,
        darken: this.select.some((v) => (v.reject.indexOf(material.id) !== -1 && v.domain !== material.domain)),
      };
    },
  },
});

